/**
 * 特殊キー（修飾キーやナビゲーションキー）の定義
 * これらのキーは見た目が異なる表示になる
 */
export const specialKeys = new Set([
  'Control', 'Shift', 'Alt', 'Meta', 'OS', 'Tab', 'Enter', 'Escape',
  'CapsLock', 'Backspace', 'Delete', 'Home', 'End', 'PageUp', 'PageDown'
])
